import { gql } from "@apollo/client";

export const configurableTypeFragment = gql`
  fragment ConfigurableTypeFragment on ConfigurableType {
    name
    code
    properties {
      name
      code
      datatype
      mandatory
    }
    elements {
      name
      code
      elementType {
        code
        name
        properties {
          name
          code
          datatype
          mandatory
        }
        identifiers {
          name
          code
          identifierType {
            name
            code
          }
          sourceProperties {
            datatype
          }
        }
      }
    }
  }
`;
